import DetailPages from './DetailPages'
export default DetailPages;